import styled from 'styled-components'

export const DialogActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 22px;

  button:first-child {
    margin-right: 15px;
  }
`

export const DialogTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px;
  font-size: 18px;
`

export const DialogTitleText = styled.span`
  color: #3B4A5D;
  font-weight: var(--font-weight-semibold);
`

export const DialogTitleIcon = styled.span`
  font-weight: var(--font-weight-semibold);

  ::before {
    content: 'X';
  }
`

export const DialogContentText = styled.div`
  color: #3B4A5D;
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  margin-bottom: 8px;
`

export const DialogContentTile = styled.div`
  color: #3B4A5D;
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  margin: 24px 0px 8px 0px; 
`

export const DialogContentSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px auto 8px auto;

  .dialog__content--checkbox {
    width: 100%;
    margin-bottom: 16px;
  }

  .dialog__content--main {
    display: flex;
    align-items: flex-start; 
    justify-content: space-between;
    margin-top: -12px;       
  }

  .dialog__content--text {
    width: 50%;
    margin-bottom: 8px;

    .dialog__content--text--title {
      margin-top: 20px;      
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: center;
      color: var(--color-feedback-danger-300);
      gap: 6px;
      justify-content: center;
    }

    p {
      margin-top: 5px;
      font-weight: var(--font-weight-regular);
      font-size: 14px;
      text-align: center;
    }
  }

  .dialog__content--action {
    width: 49%;
    margin-top: 0;   
    padding-top: 0;

    .dialog__content--action-fisrt-line {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

    .one-column-full-width {
      grid-template-columns: 1fr;
    }
    
    .date-time-row {
      display: flex;
      gap: 16px;
      width: 100%;
      margin-top: 16px;
      align-items: flex-end;
  }

    .date-range {
      flex: 1;
    } 
  }
`;
